import React from 'react';
import ImageVerifyInfo from './ImageVerifyInfo';
import Layout from '../../components/Layout/Layout';



export default async function action({ store }) {
    const title = 'VeriffVerification';

    let isAuthenticated = store.getState().runtime.isAuthenticated;

    if (!isAuthenticated) {
        return { redirect: '/login' };
    }

    let account = store.getState().account;

    if (account) {
        let verify = account.data.verification.isVerify;
        if (verify == 1) {
            return { redirect: '/user/verification' };
        }
    }

    return {
        title,
        component: <Layout><ImageVerifyInfo title={title} /></Layout>,
    };
};


